<template>
    <div>
      <div 
        style="zoom: 55%" 
        :class="{ 'mobileRight' : styleMobile === 'right' , 'mobileLeft' : styleMobile === 'left'}"
        class="marvel-device iphone-x"
      >
        <div class="notch">
          <div class="camera"></div>
          <div class="speaker"></div>
        </div>
        <div class="top-bar"></div>
        <div class="sleep"></div>
        <div class="bottom-bar"></div>
        <div class="volume"></div>
        <div class="overflow">
          <div class="shadow shadow--tr"></div>
          <div class="shadow shadow--tl"></div>
          <div class="shadow shadow--br"></div>
          <div class="shadow shadow--bl"></div>
        </div>
        <div class="inner-shadow"></div>
        <div :class="image"></div>
      </div>
      <v-card-text>
        
        <div>
          <slot></slot>
        </div>
      </v-card-text>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      title: {
        type: String,
        default: "",
      },
      name: {
        type: String,
        default: "",
      },
      styleMobile:{
        type: String,
        default: "",
      }
    },
    computed: {
      image() {
        return {
          screen: true,
          [this.name]: true,
        };
      },
    },
  };
  </script>
  
  <style scoped>
    @import url("./mobileCss.css");
    .mobileRight{
      right: -120px;
    }
    .mobileLeft{
      left: -100px;
    }
    /* iPad Portrait */
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
      .mobileRight{
        right: -20px;
      }
      .mobileLeft{
        left: -30px;
      }
    }
    @media only screen and (min-width: 1024px) and (max-width: 1199px){
      .mobileRight{
        right: -20px;
      }
      .mobileLeft{
        left: -30px;
      }
    }
    @media only screen and (min-width: 480px) and (max-width: 767px){
      .mobileRight{
        right: -20px;
      }
      .mobileLeft{
        left: -30px;
      }
    }
  </style>